import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

import { ROUTING_PATH } from '@shared/constants/routingPath';

@Component({
  imports: [RouterLink],
  selector: 'aux-no-prepaids-overlay',
  templateUrl: './no-prepaids-overlay.component.html',
})
export class NoPrepaidsOverlayComponent implements ICellRendererAngularComp {
  readonly invoiceLibraryPage = `/${ROUTING_PATH.CLOSING.INDEX}/${ROUTING_PATH.CLOSING.INVOICES_AND_PREPAIDS.INDEX}/${ROUTING_PATH.CLOSING.INVOICES_AND_PREPAIDS.INVOICES}`;

  agInit(): void {}

  refresh(): boolean {
    return false;
  }
}
